import { render, staticRenderFns } from "./softgamings.vue?vue&type=template&id=36bf8807"
import script from "./softgamings.vue?vue&type=script&lang=js"
export * from "./softgamings.vue?vue&type=script&lang=js"
import style0 from "./softgamings.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/softgamings.vue
// module id = jhHn
// module chunks = 0